import { useEffect, useState } from "react"
import { motion } from "motion/react"
import { IconChevronLeftOutline18 as ChevronLeftIcon } from "nucleo-ui-outline-18"

import { Button } from "@productlane/ui"

import type { RouterOutputs } from "@/lib/api"
import { analytics } from "@/lib/analytics"
import { trackTrialStartedConversion } from "@/lib/google-ads"
import { useSession } from "@/lib/session"
import { CreateWorkspaceTab } from "./create-workspace-tab"
import { JoinWorkspaceTab } from "./join-workspaces-tab"

export function GetStartedSlide({
	nextSlide,
	allowedDomains,
}: {
	nextSlide: () => void
	allowedDomains: RouterOutputs["user"]["allowedDomains"]
}) {
	const [view, setView] = useState<"join" | "create">("join")

	const { session } = useSession()

	useEffect(() => {
		analytics.track("setup-workspace-started", {
			userId: session?.userId,
			workspaceId: session?.workspaceId,
		})
	}, [session])

	// A new workspace starts a 7-day trial, so this is our Google Ads
	// "Trial started" conversion (the primary signal used for bid optimization).
	const handleWorkspaceCreated = () => {
		trackTrialStartedConversion()
		nextSlide()
	}

	const hasDomains = allowedDomains && allowedDomains.length > 0

	return (
		<motion.div className="flex w-full items-center justify-center">
			<div className="w-full max-w-lg">
				{hasDomains && view === "join" ? (
					<JoinWorkspaceTab
						allowedDomains={allowedDomains}
						onCreateNew={() => setView("create")}
					/>
				) : (
					<div className="mx-auto flex w-full max-w-md flex-col">
						{hasDomains && (
							<Button
								variant="link"
								size="lg"
								Icon={ChevronLeftIcon}
								onClick={() => setView("join")}
								className="mb-4 mr-auto"
							>
								Back
							</Button>
						)}
						<CreateWorkspaceTab
							displayHeader
							onCreated={handleWorkspaceCreated}
						/>
					</div>
				)}
			</div>
		</motion.div>
	)
}
